<div class="top-section">
    <h5 class="heading mb-0">{{ ss.texts()['common_attachment'] }}</h5>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>

<div class="body-section position-relative ri-w-full">
    <div class="list-items-block ri-w-full">
        <div class="category-item ri-px-4 ri-py-4 ri-w-full">
            <div class="flex justify-between ri-w-full items-center">
                <button class="outline-none" (click)="$event.stopPropagation();">
                    <span class="text-14-400 color-8">{{ ss.texts()['common_groupBy'] }}</span>
                </button>
                <app-input-dropdown [signal]="groupBy" [config]="groupByConfig" (select)="onGroupByChange()"
                    textClass="text-16-400 whitespace-nowrap"></app-input-dropdown>
            </div>
        </div>
    </div>
</div>
